module.exports = __webpack_public_path__ + "media/images/flickr-6922320fbd242c5ffbc763c29405d68e.png";